import { useState } from "react";

export const useEditorTimelineClock = () => {
  const [millSeconds, setMillSeconds] = useState(0);
  const [seconds, setSeconds] = useState(0);

  const pixelToTimeConverter = (markerPosn) => {
    let sec = Math.trunc(markerPosn / 45);
    let milliSecs = Math.ceil((markerPosn / 45 - sec) * 10) * 10;
    if (milliSecs === 100) {
      sec = sec + 1;
      milliSecs = 0;
    }
    setSeconds(sec);
    setMillSeconds(milliSecs);
  };

  return {
    millSeconds,
    seconds,
    setMillSeconds,
    setSeconds,
    pixelToTimeConverter,
  };
};
